import { isYoutubeUrl } from '@orientaction/utils';

export const DEFAULT_MAX_UPLOAD_BYTES = 500 * 1024 * 1024;

export const formatMaxUploadMo = (bytes: number) =>
  `${Math.round(bytes / (1024 * 1024))} Mo`;

export { isYoutubeUrl };

export const toBinaryFlag = (value: boolean): 0 | 1 => (value ? 1 : 0);
